import React from "react";
import Page, { PageProps } from "../../Page";
import DisplayForm from "../../../components/form/DisplayForm";
import { IApplicantFormDetailsPresenter } from "../../../../presenter/applicants/ApplicantFormDetailsPresenter";

export interface Props extends PageProps {}
export interface State extends IApplicantFormDetailsPresenter {}

export default class ApplicantFormDetails extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    let { formSectionList, translate } = this.state;

    return (
      <Page {...this.props}>
        <DisplayForm
          formSectionList={formSectionList}
          loading={this.state.loaders.applicantFormDetailsLoader}
          translate={translate}
          isEditableForm={false}
          isDraftFormVersion={() => false}
          isPreviousForm={true}
          className={"display-applicant-form-container"}
          allowedFileTypes=""
        />
      </Page>
    );
  }
}
